import './BulkAddSelectionContextWidget.scss';
import { BulkAddLimitPopover } from './BulkAddLimitPopover';
import { BulkFollowButtons } from './BulkFollowButtons';
import classNames from 'classnames';
import { DataDictionaryBulkEditModal } from '@dictionary/DataDictionaryBulkEditModal';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { When } from 'react-if';
import { Button, Card, Space } from 'antd';
import { COPY_SPECIFIC, MESSAGES_COPY } from '@sonar-software/sonar-ts-constants';
import React, { useCallback, useRef } from 'react';
import { useBoolean, useGlobalSelect } from '@hooks';
const MAX_ENTITIES = 1000;
export const BulkAddSelectionContextWidget = () => {
    const [showModal, setShowModal] = useBoolean(false);
    const { removeSelection, totalCount, globalSelection } = useGlobalSelect();
    const bulkEditButtonRef = useRef(null);
    const handleSubmitModal = useCallback(() => {
        setShowModal.off();
        removeSelection({ selections: [] });
    }, [removeSelection, setShowModal]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Card, { className: classNames('bulk-add-selection-context-widget', { open: Boolean(totalCount) }), ref: bulkEditButtonRef },
            React.createElement(Space, null,
                React.createElement("div", { className: 'selected' },
                    COPY_SPECIFIC.NUMBER_SELECTED(totalCount),
                    React.createElement(When, { condition: totalCount > MAX_ENTITIES },
                        React.createElement(BulkAddLimitPopover, { content: MESSAGES_COPY.BULK_ADD_INITIATIVES_LIMIT },
                            React.createElement(ExclamationCircleFilled, { className: 'bulk-add-exceeded-limit' })))),
                React.createElement(Button, { className: 'clear-selection', onClick: () => removeSelection({ selections: [] }), type: 'link' }, COPY_SPECIFIC.CLEAR_SELECTION)),
            React.createElement(Space, null,
                React.createElement(Button, { onClick: setShowModal.on }, COPY_SPECIFIC.BULK_EDIT),
                React.createElement(BulkFollowButtons, null))),
        React.createElement(DataDictionaryBulkEditModal, { onCancel: setShowModal.off, onOk: handleSubmitModal, open: showModal, popoverPosition: 'bottomRight', popoverTarget: bulkEditButtonRef, selected: globalSelection })));
};
